export const PREVIEW_LS_KEY = 'news-preview';

export const PREVIEW_ID_VALUE = 'preview';
